import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { adminPaymentService } from '../../services/paymentService';
import toast from 'react-hot-toast';

const initialState = {
  paymentMethods: [],
  isLoading: false,
  error: null,
};

export const fetchPaymentMethods = createAsyncThunk(
  'adminPayment/fetchPaymentMethods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminPaymentService.getPaymentMethods();
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to fetch payment methods');
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updatePaymentMethod = createAsyncThunk(
  'adminPayment/updatePaymentMethod',
  async ({ methodName, data }, { rejectWithValue }) => {
    try {
      const response = await adminPaymentService.updatePaymentMethod(methodName, data);
      toast.success(response.message || 'Payment method updated successfully');
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update payment method');
      return rejectWithValue(error.response?.data);
    }
  }
);

export const togglePaymentMethod = createAsyncThunk(
  'adminPayment/togglePaymentMethod',
  async (methodName, { rejectWithValue }) => {
    try {
      const response = await adminPaymentService.togglePaymentMethod(methodName);
      toast.success(response.message || 'Payment method toggled successfully');
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to toggle payment method');
      return rejectWithValue(error.response?.data);
    }
  }
);

const adminPaymentSlice = createSlice({
  name: 'adminPayment',
  initialState,
  extraReducers: (builder) => {
    builder
      // Fetch payment methods
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentMethods = action.payload.data;
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Update payment method
      .addCase(updatePaymentMethod.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePaymentMethod.fulfilled, (state, action) => {
        state.isLoading = false;
        const methodIndex = state.paymentMethods.findIndex(m => m.name === action.payload.data.name);
        if (methodIndex !== -1) {
          state.paymentMethods[methodIndex] = action.payload.data;
        }
      })
      .addCase(updatePaymentMethod.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Toggle payment method
      .addCase(togglePaymentMethod.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(togglePaymentMethod.fulfilled, (state, action) => {
        state.isLoading = false;
        const methodIndex = state.paymentMethods.findIndex(m => m.name === action.payload.data.name);
        if (methodIndex !== -1) {
          state.paymentMethods[methodIndex] = action.payload.data;
        }
      })
      .addCase(togglePaymentMethod.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default adminPaymentSlice.reducer;
